import React, { useState } from 'react';


import UploadImage from '../../assets/IconsColurs/IconsGeneral/uploadCloud.svg'

const UploadButton = ({ error = false, setValue, value = null }) => {
    const [fileName, setFileName] = useState(value != null ? "Image" : null);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setValue(file)
        if (file) {
            setFileName(file.name); // Almacena el nombre del archivo
        }
    };

    const handleButtonClick = () => {
        document.getElementById("fileInput").click();
    };

    const handleRemoveFile = () => {
        setFileName(null); // Restablece el estado
        document.getElementById("fileInput").value = ""; // Limpia el input file
    };

    return (
        <>
            <button
                onClick={fileName ? handleRemoveFile : handleButtonClick}
                className={` flex items-center justify-center w-full h-full rounded-lg text-white bg-transparent transition-colors duration-300 border ${error ? 'border-[#FF928B]' : 'border-white'}`}
            >
                {fileName ? (
                    // Botón de eliminar archivo
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 mr-2"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}>
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6 18L18 6M6 6l12 12" />
                    </svg>
                ) : (
                    // Ícono de subida
                    <img src={(UploadImage)} className='flex w-5 h-5 mr-2' style={{ color: 'white' }} />
                )}

                <span>{fileName ? fileName : "Adjuntar imagen"}</span>
            </button>

            <input
                type="file"
                id="fileInput"
                accept="image/*"
                onChange={handleFileChange}
                style={{ display: 'none' }}
            />
        </>
    );
};

export default UploadButton;
